import { css } from 'linaria';
import { DiscoverFilledIcon } from '@pocket/web-ui';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
import classNames from 'classnames';
const webOnlyWrapper = "whw7f9r";
export function WebOnlyTag({
  count,
  margin
}) {
  const className = classNames(webOnlyWrapper, buttonReset, tagBase);
  return <div className={className} style={{
    margin
  }}>
      <DiscoverFilledIcon />
      <span>{count}</span>
    </div>;
}

require("./tag-web-only.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-web-only.js");